export function VendorCtrl (
  $scope,
  $translate,
  billedVendors,
  companyMessages,
  inheritorApi,
  invoices,
  messages,
  orders,
  payments,
  paymentTerms,
  ukPostcodeApi,
  vendor
  ) {

  $scope.billedVendors   = billedVendors;
  $scope.companyMessages = companyMessages;
  $scope.invoices        = invoices;
  $scope.orders          = orders;
  $scope.payments        = payments;
  $scope.paymentTerms    = paymentTerms;
  $scope.vendor          = vendor;

  inheritorApi.inheritCtrl('VendorLiteCtrl', $scope);

  $scope.searchUKPostcode = function () {
    ukPostcodeApi.search($scope.vendor.postcode)
    .then(data => {
      $scope.vendor.address1 = data.Premises;
      $scope.vendor.address2 = data.Street;
      $scope.vendor.suburb   = data.PostTown;
      $scope.vendor.postcode = data.Postcode;

      messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.SUPPLIER_ADDRESS'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };
}